import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article1() {

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';
      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';
      return "";
    }
  };



  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 3
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article2');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()}  */}
          <img id="img1" className="active" src={require("../../Images/1-MADE-OF-CROVIE.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article1-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/1-MADE-OF-CROVIE.jpg")} alt="" />
          </motion.div>
          <motion.div
            variants={textAnimate}
            className="hamburger-menu">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
        <div className="article-mob-wrap">
          <div className="mb-4 mb-sm-5" ref={firstContainer}>
            <div
              variants={textAnimate}
            >
              <h1 className="fs-xl f-lora mb-3">Made <span className="f-lora-i">of</span> <br/>CROVIE</h1>
              <h2 className="f-lora-i mb-4 mb-sm-5">Growing up on the <br />edge of the ocean.</h2>
            </div>
            <h6 className="font-italic" variants={textAnimate}>words - Emily Rose Mawson & photography - Jack Cairney</h6>
            <p className="text-blue fw-semibold" variants={textAnimate}>Crovie perches perilously between cliffs and sea, a solitary row of houses huddled gable-end to the waves in an Aberdeenshire bay. Its fishing days long gone, people come and go, but this tiny salt-worn village retains an unparalleled magic. Here, local lad Jamie Ellington recalls growing up on the edge of the ocean.</p>
            <div variants={textAnimate} className="short-divder"></div>
            <p variants={textAnimate}>On a 1980s afternoon, a little Crovie boy rockpools on the narrow pebble beach that separates his village from the ocean. He builds forts, and occasionally pesters the fishermen who are gutting their catch in the stream. When he's done, he'll find a spot in the seagrass to read. His cottage is the caramel-coloured fishing cottage, right there, the one with big windows onto the Moray Firth. It's squeezed into the huddle of stone cottages, piled up like Duplo bricks, where the rounded grass-carpeted cliffs encircling the bay fold into the ocean. The water is calm just now, and the boy won't have to leapfrog the waves as he walks home along the single path that connects the houses. But his parents are checking the shipping forecast anyway - it's essential if you live in Crovie, the roadless fishing village between Fraserburgh and Banff. If a storm is drifting inland, everyone will have to race out to put the shutters up or rocks will be hurled through the windows. That's why most of the cottages cower gable-end to the sea.</p>
            <p variants={textAnimate}>“Crovie is a magical place,” summarises now-34-year-old Jamie Ellington. He grew up at No. 30, the house his parents built as newlyweds. These days, the family let out the property as a holiday cottage, “where you feel like you have gone back in time and can imagine what it was like to live a simpler life”, according to one recent guest. If the pared-back maritime interiors let the shush of the waves do the talking, a slew of original features lend character: there's the original stone floor (“which retains heat and makes it nice and cosy,” says Jamie); a hatch in the kitchen; and even a coal fireplace. “I've seen photos of me having a bath in front of it as a baby which, thinking about it, for the 1980s is pretty old-world,” he remembers.</p>

            <p variants={textAnimate}>Jamie's 2020s stomping ground is Brooklyn, New York, where he runs a photography studio with clients including Calvin Klein and the Italian menswear brand Isaia. He has also worked with the likes of Jake Gyllenhaal and Rami Malek, who he directed interviews with for Cartier. But it was in Crovie that he honed his skills. He describes his childhood as “saturated with art and music”. His dad's side of the family were musicians, and his parents were both artists: his mum a talented line drawer and rug maker, and his dad, a photographer, whom he would accompany to the Lonach Highland Gathering, as well as old fish-smoking houses and local auctions, so his father could “photograph the people keeping history alive”.</p>
            
          </div>
          
          <div className="secondSec" ref={secondContainer}>
            <img variants={textAnimate}
              src={require("../../Images/article1-right-img1.jpg")}
              className={"w-100 mb-4 mb-sm-5"}
              alt=""
            />
            <br className="mb-4" />
            <hr className="text-brown" />
            <h3 variants={textAnimate} className="text-brown fw-normal my-4 pe-4 f-lora-i">“It's perfectly itself and consistently so thanks to the hard work of the residents who love and look after it.”</h3>
            <hr className="text-brown mb-4 mb-sm-5" />
            <p variants={textAnimate}>Jamie was 15 years old when his dad gave him a camera and instead of suggesting tuition, told him to just go and take pictures - “usually of seascapes and people”, he says. “In summer,” he remembers, “there would be a guitar or a fiddle knocking around that someone would play on the benches outside.” The summer sun doesn't set in Crovie until about 10pm and the evenings can be warm, he continues, so everyone who is in the village sits in front of their cottage or walks to the end of the sea wall and back.</p>
            <p variants={textAnimate}>These days, most people come and go with the seasons, says Jamie, whose childhood Crovie had ten permanent residents, and no other children. Crovie's heyday was in the 18th century, when some 300 people lived in the village, many of them farmers resettled after the Clearances and earning a living from the sea, though there are records of a settlement in this location dating back as far as 1004. Crovie as a fishing hub continued to thrive until January 1953, when devastating storms tore along the coastline, destroying several cottages and forcing the residents to flee. With most locals reluctant to return, the local council planned to bulldoze the entire village.</p>
            <p variants={textAnimate}>It is only thanks to the intervention of a group of owners that the pretty village stands today. The very same year as the storms, they joined forces to form the Crovie Preservation Society and restore Crovie as a living village. It now has Conservation status, and 2023 marks 60 years since the society's founding.</p>
            <br />
            <img
              src={require("../../Images/article1-right-img2.jpg")}
              className={"w-100 mb-4"}
              alt=""
            />
            
            <img
              src={require("../../Images/article1-right-img3.jpg")}
              className={"w-100 mb-4"}
              alt=""
            />
            <img
              src={require("../../Images/article1-right-img4.jpg")}
              className={"w-100 mb-4 mb-sm-5"}
              alt=""
            />
            <p variants={textAnimate}>There is still no road access - the ledge on which Crovie is situated is simply too narrow, the village suspended almost like a CGI-animation between cliffs and sea - but it is far from cut off. When the tide is out you can walk along the bouldered shore to get to Gardenstown, or it's an 8.5-kilometre circular to the spectacular sandstone cliffs of Troup Head Nature Reserve. In a setting described by the Scottish historian Charles McKean as having “one of the finest viewpoints in Scotland”, you can spot Scotland's largest mainland gannet colony, thousands of kittiwakes, guillemots and razorbills, and if you're lucky, porpoises, dolphins, and even minke whales. Jamie remembers childhood days out involving drives to Memsie to see his grandma, or to Fraserburgh to the Museum of Scottish Lighthouses. Yes, he says, there is lots to see and do in the north-east.</p>
            <p variants={textAnimate}>Jamie regularly returns to Crovie, “for longer periods of time the older I get”. There are some new windows here and there, and the tiles have been replaced on a few cottages. “It’s perfectly itself and consistently so thanks to the hard work of the residents who love and look after it,” he says.</p>

          </div>
          
        </div>
        </div>
      </motion.div>

      <div className="btns-group">
        
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>

    </motion.div>

  );
}

export default Article1;
